import { defineMessages } from 'react-intl';

const messages = defineMessages({
  assetsSearchInputLabel: {
    id: 'assetsSearchInputLabel',
    defaultMessage: 'Search',
    description: 'Label for search input',
  },
  assetsSearchSubmitLabel: {
    id: 'assetsSearchSubmitLabel',
    defaultMessage: 'Submit search',
    description: 'Label for search submit button that has a magnifying glass icon',
  },
  assetsClearSearchButtonLabel: {
    id: 'assetsClearSearchButtonLabel',
    defaultMessage: 'Clear search',
    description: 'Label for a button that clears the search applied to a table.',
  },
});

export default messages;
